// Adds Authorization: Bearer <token> to every $http request except token endpoints.
// Registered in frontend.ts alongside myHttpInterceptor.

frontendApp.factory('AuthInterceptor', ['$injector', function($injector: any) {
  let tokenService: any;
  let configService: any;
  return {
    request: function(config: any) {
      const url: string = config.url || '';
      // Skip token endpoints — they use Basic auth set directly by TokenService
      if (/\/oauth\/(token|check_token)/.test(url)) return config;
      // Skip external URLs that don't belong to our API server
      if (url.startsWith('http')) {
        configService = configService || $injector.get('ConfigService');
        if (!url.startsWith(configService.getServerBaseUrl())) return config;
      }
      tokenService = tokenService || $injector.get('TokenService');
      const token = tokenService.GetAccessToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    }
  };
}]);
